import _defineProperty from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { PureComponent } from '../component';
import { getParent } from '../utils/dom/element';
import { eventPassive } from '../utils/dom/detect';
import { defaultProps } from '../utils/defaultProps';
import { compose } from '../utils/func';
import { cssSupport, copyBoundingClientRect } from '../utils/dom/element';
import { docSize } from '../utils/dom/document';
import { consumer } from './context';
var events = ['scroll', 'pageshow', 'load'];
var supportSticky = cssSupport('position', 'sticky');
var defaultZIndex = 900;

var DefaultValue = _objectSpread2(_objectSpread2({}, defaultProps), {}, {
  css: true
});

var Sticky =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Sticky, _PureComponent);

  var _super = _createSuper2(Sticky);

  function Sticky(props) {
    var _this;

    _classCallCheck(this, Sticky);

    _this = _super.call(this, props);
    _this.style = void 0;
    _this.targetElement = void 0;
    _this.element = void 0;
    _this.scrollTimer = void 0;
    _this.placeholder = void 0;
    _this.origin = void 0;
    _this.locked = void 0;
    _this.scrollCount = void 0;
    _this.state = {};
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    _this.bindOrigin = _this.bindOrigin.bind(_assertThisInitialized(_this));
    _this.bindPlaceholder = _this.bindPlaceholder.bind(_assertThisInitialized(_this));
    _this.handlePosition = _this.handlePosition.bind(_assertThisInitialized(_this));
    _this.style = {};
    return _this;
  }

  _createClass(Sticky, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _get(_getPrototypeOf(Sticky.prototype), "componentDidMount", this).call(this);

      var target = this.props.target;
      this.targetElement = getParent(this.element, target);
      this.handlePosition();

      if (!this.shouldUseCss) {
        this.bindScroll();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.needResetPostion && this.props.needResetPostion) {
        this.setPosition();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _get(_getPrototypeOf(Sticky.prototype), "componentWillUnmount", this).call(this);

      this.unbindScroll();
      if (this.scrollTimer) clearTimeout(this.scrollTimer);
    }
  }, {
    key: "getStyle",
    value: function getStyle(mode, offset, left, width) {
      var _style;

      var _ref = this.props.style,
          _ref$zIndex = _ref.zIndex,
          zIndex = _ref$zIndex === void 0 ? 900 : _ref$zIndex;
      var css = this.props.css;
      var style = (_style = {
        position: 'fixed',
        left: left,
        width: width
      }, _defineProperty(_style, mode, offset), _defineProperty(_style, "zIndex", zIndex), _style);

      if (this.targetElement) {
        if (supportSticky && css) {
          style.position = 'sticky';
        } else {
          style.position = 'absolute';

          if (mode === 'top') {
            style.transform = "translateY(".concat(offset + this.targetElement.scrollTop, "px)");
          } else {
            style.transform = "translateY(".concat(this.targetElement.scrollTop, "px)");
          }

          delete style.left;
        }
      }

      this.triggerChange(true, style);
      return style;
    }
  }, {
    key: "setPosition",
    value: function setPosition() {
      var _this$props = this.props,
          bottom = _this$props.bottom,
          top = _this$props.top,
          target = _this$props.target,
          css = _this$props.css,
          needResetPostion = _this$props.needResetPostion;
      var _this$state = this.state,
          mode = _this$state.mode,
          scrollWidth = _this$state.scrollWidth; // If it is a hidden element, the position will not be updated

      if (needResetPostion === false) return;
      var selfRect = copyBoundingClientRect(this.element);
      if (selfRect === null) return; // If the element is hidden, the width and height will be 0

      if (selfRect && selfRect.width === 0 && selfRect.height === 0) return;

      var _getComputedStyle = getComputedStyle(this.element),
          marginBottom = _getComputedStyle.marginBottom,
          marginTop = _getComputedStyle.marginTop;

      selfRect.height += parseFloat(marginBottom) + parseFloat(marginTop);
      var scrollElement = this.targetElement || document.body;
      var scrollRect = scrollElement.getBoundingClientRect();
      var placeholderRect = this.placeholder ? copyBoundingClientRect(this.placeholder) : null;
      var viewHeight = docSize.height;

      if (this.origin) {
        var _this$origin$getBound = this.origin.getBoundingClientRect(),
            width = _this$origin$getBound.width;

        selfRect.width = width;
        if (placeholderRect) placeholderRect.width = width;
      }

      var placeholderStyle = {
        width: selfRect.width,
        // if target element is not null, set height to 0
        height: target && supportSticky && css ? 0 : selfRect.height
      };
      var style;
      var placeholder;

      if (top !== undefined && mode !== 'bottom') {
        var limitTop = top;

        if (this.targetElement) {
          var _getComputedStyle2 = getComputedStyle(scrollElement),
              paddingTop = _getComputedStyle2.paddingTop;

          limitTop += scrollRect.top + parseInt(paddingTop, 10);
        }

        if (Math.ceil(selfRect.top) < limitTop) {
          this.setState({
            scrollWidth: scrollRect.width,
            mode: 'top'
          });
          style = this.getStyle('top', top, selfRect.left, selfRect.width);
          placeholder = placeholderStyle;
        } else if (placeholderRect && selfRect.top < placeholderRect.top) {
          if (scrollRect.width !== selfRect.width) {
            style = this.getStyle('top', top, selfRect.left, scrollRect.width);
          }

          if (!(target && selfRect.top === limitTop)) {
            this.setState({
              mode: ''
            });
            style = {};
            placeholder = null;
            this.triggerChange(false, style);
          }
        } else if (this.targetElement && placeholderRect) {
          style = this.getStyle('top', top, selfRect.left, selfRect.width);
          placeholder = placeholderStyle;
        } else if (scrollWidth && placeholderRect && scrollWidth !== scrollRect.width) {
          this.setState({
            scrollWidth: scrollRect.width,
            mode: 'top'
          });
          style = this.getStyle('top', top, placeholderRect.left, placeholderRect.width);
          placeholder = placeholderStyle;
        }
      }

      if (bottom !== undefined && mode !== 'top') {
        var limitBottom = viewHeight - bottom;

        if (this.targetElement) {
          var _getComputedStyle3 = getComputedStyle(scrollElement),
              paddingBottom = _getComputedStyle3.paddingBottom;

          limitBottom = scrollRect.bottom - bottom - parseInt(paddingBottom, 10);
        }

        if (selfRect.bottom > limitBottom) {
          this.setState({
            scrollWidth: scrollRect.width,
            mode: 'bottom'
          });
          style = this.getStyle('bottom', bottom, selfRect.left, selfRect.width);
          placeholder = placeholderStyle;
        } else if (placeholderRect && (this.targetElement ? scrollRect.bottom : selfRect.bottom) > placeholderRect.bottom) {
          if (scrollRect.width !== selfRect.width) {
            style = this.getStyle('bottom', bottom, selfRect.left, scrollRect.width);
          }

          if (!(target && selfRect.bottom === limitBottom)) {
            this.setState({
              mode: ''
            });
            style = {};
            placeholder = null;
            this.triggerChange(false, style);
          }
        } else if (this.targetElement && placeholderRect) {
          style = this.getStyle('bottom', bottom, selfRect.left, selfRect.width);
          placeholder = placeholderStyle;
        } else if (scrollWidth && placeholderRect && scrollWidth !== scrollRect.width) {
          this.setState({
            scrollWidth: scrollRect.width,
            mode: 'bottom'
          });
          style = this.getStyle('bottom', bottom, placeholderRect.left, placeholderRect.width);
          placeholder = placeholderStyle;
        }
      }

      if (placeholder !== undefined) {
        this.setState({
          placeholder: placeholder
        });
      }

      if (style) {
        this.style = style;
        this.setState({
          style: style
        });
      }
    }
  }, {
    key: "triggerChange",
    value: function triggerChange(flag, style) {
      var onChange = this.props.onChange;
      if (style.position === this.style.position) return;
      if (typeof onChange === 'function') onChange(flag);
    }
  }, {
    key: "handlePosition",
    value: function handlePosition() {
      var _this2 = this;

      var css = this.props.css;

      if (this.locked && css) {
        this.scrollCount += 1;
        return;
      }

      this.locked = true;
      this.scrollCount = 0;
      this.setPosition();
      this.scrollTimer = setTimeout(function () {
        _this2.locked = false;

        if (_this2.scrollCount > 0) {
          _this2.handlePosition();
        }
      }, 48);
    }
  }, {
    key: "bindElement",
    value: function bindElement(el) {
      this.element = el;
    }
  }, {
    key: "bindOrigin",
    value: function bindOrigin(el) {
      this.origin = el;
    }
  }, {
    key: "bindPlaceholder",
    value: function bindPlaceholder(el) {
      this.placeholder = el;
    }
  }, {
    key: "bindScroll",
    value: function bindScroll() {
      var _this3 = this;

      if (this.targetElement) {
        this.targetElement.addEventListener('scroll', this.handlePosition, eventPassive);
      } else {
        events.forEach(function (e) {
          window.addEventListener(e, _this3.handlePosition);
        });
      }

      window.addEventListener('resize', this.handlePosition);
    }
  }, {
    key: "unbindScroll",
    value: function unbindScroll() {
      var _this4 = this;

      if (this.targetElement) {
        this.targetElement.removeEventListener('scroll', this.handlePosition);
      } else {
        events.forEach(function (e) {
          window.removeEventListener(e, _this4.handlePosition);
        });
      }

      window.removeEventListener('resize', this.handlePosition);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          target = _this$props2.target,
          css = _this$props2.css,
          top = _this$props2.top,
          bottom = _this$props2.bottom;
      var placeholder = this.state.placeholder;
      var outerStyle = this.props.style;
      var innerStyle = this.state.style;

      if (target && supportSticky && css) {
        outerStyle = Object.assign({
          zIndex: defaultZIndex
        }, outerStyle, {
          position: 'sticky',
          top: top,
          bottom: bottom
        });
        innerStyle = {};
      }

      return (
        /*#__PURE__*/
        React.createElement("div", {
          style: outerStyle,
          className: className
        },
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.bindElement,
          style: Object.assign({}, innerStyle, {
            display: 'flow-root'
          })
        }, children),
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.bindOrigin
        }), placeholder &&
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.bindPlaceholder,
          style: placeholder
        }))
      );
    }
  }, {
    key: "shouldUseCss",
    get: function get() {
      var css = this.props.css;

      if (css && supportSticky && this.targetElement) {
        return true;
      }

      return false;
    }
  }]);

  return Sticky;
}(PureComponent);

Sticky.displayName = 'ShineoutSticky';
Sticky.defaultProps = DefaultValue;
export default compose(consumer)(Sticky);